import React from 'react';

// Communications icons mirror Umbrella's comms feed, which uses Google Material Icons
// (umbrella/src/components/CommunicationFeedItems: Email -> 'email', Sms -> 'smartphone',
// PhoneCall -> 'phone'). The Material glyphs are inlined as SVG so we match Umbrella exactly
// without pulling the Material Icons font into a Mortar app. Paths are the Material Design
// 24x24 filled glyphs. `fill="currentColor"` lets styling control the color; size is set in styles.ts.

const Glyph: React.FC<{ label: string; path: string; color: string }> = ({
  label,
  path,
  color,
}) => (
  <svg viewBox="0 0 24 24" role="img" aria-label={label} focusable="false" style={{ color }}>
    <path d={path} fill="currentColor" />
  </svg>
);

export const EmailIcon: React.FC<{ label: string; color: string }> = ({ label, color }) => (
  <Glyph
    label={label}
    color={color}
    path="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
  />
);

export const SmsIcon: React.FC<{ label: string; color: string }> = ({ label, color }) => (
  <Glyph
    label={label}
    color={color}
    path="M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
  />
);

export const PhoneIcon: React.FC<{ label: string; color: string }> = ({ label, color }) => (
  <Glyph
    label={label}
    color={color}
    path="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
  />
);
